import { __require as i } from "./map_object.js";
var r, e;
function s() {
  if (e) return r;
  e = 1;
  var u = i();
  return r = function(a) {
    return u(a, function(t, n) {
      return t;
    });
  }, r;
}
export {
  s as __require
};
